import { useLocation } from "react-router-dom";
import { Construction } from "lucide-react";

const PlaceholderPage = () => {
  const location = useLocation();
  const pageName = location.pathname.replace("/", "").replace(/-/g, " ") || "Page";

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <div className="w-16 h-16 rounded-2xl bg-[#F1F5F9] flex items-center justify-center mx-auto mb-4">
          <Construction className="w-8 h-8 text-[#94A3B8]" />
        </div>
        <h2 className="text-[20px] font-bold text-[#1E293B] capitalize mb-1">{pageName}</h2>
        <p className="text-[13px] text-[#94A3B8]">This section is coming soon</p>
      </div>
    </div>
  );
};

export default PlaceholderPage;
